// extracted by mini-css-extract-plugin
export var cardContainer = "_nt-0";
export var cardHeader = "_nt-2";
export var collapsedState = "_nt-3";
export var dragHandle = "_nt-5";
export var dragHandleIcon = "_nt-6";
export var dragging = "_nt-1";
export var titleArea = "_nt-4";